import { ButtonGroup } from "@mui/material";
import { feetOptions, inchesOptions } from "../../options.utils";
import Select from "./Select";
interface HeightProps {
  name?: string;
  readOnly?: boolean;
}
const Height: React.FC<HeightProps> = ({ name, readOnly }) => {
  return (
    <ButtonGroup fullWidth>
      <Select
        label='Feet'
        name={name ? `${name}.feet` : "feet"}
        options={feetOptions}
        readOnly={readOnly}
        required = {true}
      />
      <Select
        label='Inches'
        name={name ? `${name}.inches` : "inches"}
        options={inchesOptions}
        readOnly={readOnly}
        required = {true}
      />
    </ButtonGroup>
  );
};

export default Height;
